import React from "react";
import { useEffect, useState, useContext } from "react";
import Slider from "react-slick";
import blogimg from "../images/blogimg.png";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./blogs.css";
import BlogIdContext from "../Context/BlogIdContext";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;

  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "black",
        padding: "20px",
        zIndex: 1,
        borderRadius: "30px",
      }}
      onClick={onClick}
    />
  );
}

function Blogs() {
  const [blogId, setBlogId] = useContext(BlogIdContext);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch("/blogs")
      .then((response) => response.json())
      .then((response) => {
        // console.log(response)
        setBlogs(response);
      });
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,

    slidesToShow: blogs.length >= 3 ? 3 : blogs.length === 2 ? 2 : 1,
    slidesToScroll: 3,
    // adaptiveHeight: true,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleClick = (e) => {
    setBlogId(e.target.id);

    console.log("id", blogId);
  };

  return (
    <div className="container">
      <p className="container_heading">
        <span className="heading_first">Latest</span> Blogs
      </p>

      <div className="blog_cards">
        <Slider {...settings}>
          {blogs &&
            blogs.map((blog) => (
              <div
                key={blog._id}
                id={blog._id}
                onClick={handleClick}
                className="blog_card"
              >
                {/* {console.log(blog.blogImage?`https://freelance-project-1-bucket.s3.ap-south-1.amazonaws.com/blog-images/${blog.blogImage.path}`:"11")} */}
                <img
                  id={blog._id}
                  onClick={handleClick}
                  className="blog_img"
                  src={
                    blog.blogImage
                      ? `https://skylark-website-images.s3.ap-south-1.amazonaws.com/blog-images/${blog.blogImage.path}`
                      : blogimg
                  }
                />

                <Link
                  style={{ textDecoration: "none" }}
                  to={"/blogDetail"}
                  state={blog ? blog._id : "1"}
                >
                  <div
                    id={blog._id}
                    onClick={handleClick}
                    className="blog_text"
                  >
                    <p className="blog_title">{blog.title}</p>

                    {/* <p className="blog_content">{blog.content}</p> */}
                    <div
                      className="blog_content"
                      dangerouslySetInnerHTML={{
                        __html: blog ? blog.Card_Content : "",
                      }}
                    ></div>
                    {/* {console.log(new Date(blog.createdAt).toDateString())} */}
                    <p className="blog_date">
                      {new Date(blog.createdAt).toDateString()}
                    </p>
                  </div>
                </Link>
              </div>
            ))}
        </Slider>
      </div>
    </div>
  );
}

export default Blogs;
